var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cube-query" }, [
    _c("div", { staticClass: "J-select-cube" }, [
      _c("div", { staticClass: "guid-tip-container" }, [
        _c("div", { staticClass: "select" }, [
          _c(
            "div",
            { staticClass: "input", class: { "select-open": _vm.isOpen } },
            [
              _c(
                "span",
                {
                  staticClass: "J-current",
                  attrs: { title: _vm.getSelectName },
                },
                [_vm._v(_vm._s(_vm.getSelectName))]
              ),
              _vm._v(" "),
              _c(
                "el-dropdown",
                {
                  attrs: { disabled: _vm.isDown },
                  on: { command: _vm.previewDetail },
                },
                [
                  _c(
                    "el-tooltip",
                    { attrs: { disabled: !_vm.isDown, placement: "left" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { width: "100px", color: "#fff" },
                          attrs: { slot: "content" },
                          slot: "content",
                        },
                        [_vm._v("此指标已下架")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "el-dropdown-link" }, [
                        _c("i", { staticClass: "el-icon-more" }),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    {
                      staticClass: "jzliu-bi-engine-cube-query-dropdown-menu",
                      attrs: { slot: "dropdown" },
                      slot: "dropdown",
                    },
                    [
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "previewDetail" } },
                        [_vm._v("预览明细数据")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isOpen
            ? _c("div", { staticClass: "dropdown-menu" }, [
                _c("div", { staticClass: "dropdown-position-wrapper" }, [
                  _c("div", { staticClass: "dropdown-menu-data" }, [
                    _c("div", { staticClass: "cube-file-tree" }, [
                      _c(
                        "ul",
                        { staticClass: "ui-schema-antd-tree" },
                        _vm._l(_vm.list, function (i) {
                          return _c(
                            "li",
                            {
                              class: { "active-li": i.id === _vm.value },
                              on: {
                                click: function ($event) {
                                  return _vm.selectClick(i)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(i.label) +
                                  "\n                  "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-menu-oper" }),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }